"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _WalletDetailsContainer = _interopRequireDefault(require("../../components/WalletDetails/WalletDetailsContainer"));
var _RecentActivityWithFilter = _interopRequireDefault(require("../../components/RecentActivityWithFilter"));
var _TransfersContainer = _interopRequireDefault(require("../../components/Transfers/TransfersContainer"));
var _TransfersFilters = _interopRequireDefault(require("../../components/Transfers/TransfersFilters"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _config = _interopRequireDefault(require("../../config"));
require("./WalletDetailsLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var walletDetailsLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-details-layout');
var WalletDetailsLayout = function WalletDetailsLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: walletDetailsLayoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletDetailsLayoutClasses('wallet-details')
  }, /*#__PURE__*/_react["default"].createElement(_WalletDetailsContainer["default"], null)), _config["default"].global.allowTransfer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: walletDetailsLayoutClasses('transfers')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletDetailsLayoutClasses('transfers-header')
  }, t('Transfers')), /*#__PURE__*/_react["default"].createElement(_TransfersFilters["default"], null), /*#__PURE__*/_react["default"].createElement(_TransfersContainer["default"], null)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletDetailsLayoutClasses('recent-activity')
  }, /*#__PURE__*/_react["default"].createElement(_RecentActivityWithFilter["default"], {
    filterForSelected: true
  })));
};
var _default = exports["default"] = WalletDetailsLayout;